export default __webpack_public_path__ + "static/media/section1-bg4.086e8a22.png";